<template>
	<DialogFormDialog
		ref="dialog"
		:strings="strings"
		:max-width="540"
		@reset="reset"
	>
		<v-autocomplete
			v-model="userSource"
			:items="userSources"
			:search-input.sync="userSourceFilter"
			placeholder="Community user belongs to"
			autocomplete="off"
			clearable
			dense
		>
			<template #item="{ item }">
				<v-list-item-avatar>
					<v-icon small>{{
						item.value.type === "association_group"
							? "fa-users"
							: "far fa-building"
					}}</v-icon>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title>{{ item.text }}</v-list-item-title>
					<v-list-item-subtitle
						><small>{{
							item.value.type === "association_group"
								? "Access Group"
								: "Community"
						}}</small></v-list-item-subtitle
					>
				</v-list-item-content>
			</template>
		</v-autocomplete>

		<v-autocomplete
			v-model="values.users"
			:loading="loading"
			:items="items"
			:search-input.sync="search"
			:disabled="!userSource"
			placeholder="User"
			autocomplete="off"
			chips
			clearable
			multiple
		/>
	</DialogFormDialog>
</template>

<script>
import _ from "lodash";

import strings from "@/utils/strings";
import { createUser } from "@/store/model";

import { mapActions } from "vuex";

const initData = () => ({
	strings: strings.project.dialogs.addUsers,

	userSource: null,
	userSourceFilter: null,

	loading: false,
	search: null,
	searchResults: [],

	values: { users: [] },
	rules: [v => !!v.length || "You must select at least one"],
});

export default {
	props: {
		users: {
			type: Array,
			required: true,
		},
	},

	data: initData,

	computed: {
		userSources() {
			const communities = this.$store.getters["communities/items"];
			const groups = this.$store.getters["accessGroups/groups"];
			return _.chain(communities.concat(groups))
				.map(item => ({
					text: item.name,
					value: item,
				}))
				.sortBy("text")
				.value();
		},

		items() {
			const existingUserIds = _.map(this.users, "guid");

			return _.chain(this.searchResults)
				.map(createUser)
				.map(user => ({
					text: user.displayName || user.email,
					value: user.guid,
					disabled: _(existingUserIds).includes(user.guid),
				}))
				.sortBy("text")
				.value();
		},
	},

	watch: {
		userSource(val) {
			val && this.doSearch(null);
		},

		search(val) {
			val && this.doSearch(val);
		},

		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	mounted() {
		this.pop = this.$refs.dialog.pop;
	},

	methods: {
		...mapActions({ userSearch: "accessGroups/userSearch" }),

		reset() {
			Object.assign(this, initData());
		},

		async doSearch(val) {
			this.loading = true;
			try {
				this.searchResults = await this.userSearch({
					associationId: this.userSource.id,
					search: val,
				});
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
